// TOUR-24 — Logistics routes board, stops, and dispatch.

import { LOGISTICS_COORDINATOR_ROLES } from "@/lib/roles/turboLogisticsRoles";
import type { FireflyTourArtifact } from "../tourTypes";

export const LOGISTICS_ROUTES_TOUR_ID = "tour-logistics-routes";

export const LOGISTICS_ROUTES_TOUR: FireflyTourArtifact = {
  id: LOGISTICS_ROUTES_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "logistics tour",
    "dispatch a route",
    "fix stop address",
    "routes tour",
    "delivery queue tour",
    "walk me through logistics routes",
    "show me the dispatch board",
    "how do i dispatch a delivery",
  ],
  bucketRelevance: ["logistics"],
  requiredRoles: [...LOGISTICS_COORDINATOR_ROLES],
  steps: [
    {
      id: "nav-routes",
      target: {
        mode: "logisticsRoutes",
        anchorId: "mode-nav-logisticsRoutes",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "logisticsRoutes",
      copy: {
        title: "Open Routes",
        body: "Delivery queue, stop timelines, and rig dispatch live here. Tap Routes in the Logistics bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "routes-surface",
      target: {
        mode: "logisticsRoutes",
        anchorId: "logi-routes-surface",
        scrollIntoView: true,
      },
      copy: {
        title: "Routes workspace",
        body: "One route equals one unit. Create planned deliveries, open a row for stops, then assign a rig on the dispatch board.",
      },
      advanceOn: "next_button",
    },
    {
      id: "routes-list",
      target: {
        mode: "logisticsRoutes",
        anchorId: "logi-routes-list",
        scrollIntoView: true,
      },
      copy: {
        title: "Delivery queue",
        body: "Filter and scan planned / scheduled / in-transit routes. Tap Open on a row to load the stops timeline and address edits.",
      },
      waitForClick: true,
    },
    {
      id: "route-stops",
      target: {
        mode: "logisticsRoutes",
        anchorId: "logi-route-stops",
        scrollIntoView: true,
      },
      copy: {
        title: "Stops and addresses",
        body: "Ordered stops show plant origin → holding → end customer. Use Edit on a stop to fix street address fields — you save the edit yourself.",
      },
      advanceOn: "next_button",
    },
    {
      id: "dispatch-board",
      target: {
        mode: "logisticsRoutes",
        anchorId: "logi-dispatch-board",
        scrollIntoView: true,
      },
      copy: {
        title: "Dispatch board",
        body: "Drag a planned delivery chip onto a rig to assign carrier + driver. Routes with a schedule flip to scheduled. You perform the drag yourself — the tour will not assign.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "logisticsRoutes", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Carrier and fleet admin live under Logistics → Carriers. Ask Firefly anytime for carriers or manufacturing plant tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
